/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Add_Subject_DescriptionInputs */



/**
* | output |
* | --- |
* | "Pick one user or team to configure. You'll set their tool access next." |
*
* @param {Rights_Tools_Add_Subject_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_add_subject_description = /** @type {((inputs?: Rights_Tools_Add_Subject_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Add_Subject_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einen Nutzer oder ein Team zum Konfigurieren auswählen. Der Tool-Zugriff wird im nächsten Schritt gesetzt.")
	return /** @type {LocalizedString} */ ("Pick one user or team to configure. You'll set their tool access next.")
});